import { useIsWebview } from '@backmarket/nuxt-module-navigation/useIsWebview'

import { RAW_MATERIALS } from '~/scopes/campaign/route-names'
import { toWebviewRouteName } from '~/scopes/webviews/utils'

export function useCampaignRouteName() {
  const isWebview = useIsWebview()

  return function routeName(route: keyof typeof RAW_MATERIALS): string {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const routeName = RAW_MATERIALS[route]

    return isWebview ? toWebviewRouteName(routeName) : routeName
  }
}
